import { render, staticRenderFns } from "./OrdersFilters.vue?vue&type=template&id=ede13eda&"
import script from "./OrdersFilters.vue?vue&type=script&lang=js&"
export * from "./OrdersFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports